import styled, { css } from 'styled-components';
import { tagTokens } from '../../tokens/components/Tag/tokens';
import { buttonTokens } from '../../tokens/components/Button/tokens';

import { resetBrowserButton } from '../Button/styles';

/* @internal */
export const tagStates = {
  clickable: css`
    &:hover {
      background: ${tagTokens.BackgroundColorInformationalHover};
      cursor: pointer;
    }

    &:active {
      background: ${tagTokens.BackgroundColorInformationalDown};
    }
  `,
  focus: css`
    &:focus-visible {
      z-index: 1;
      border-color: ${buttonTokens.BorderColorBaseKeyboardFocus};
      box-shadow: inset 0 0 0 ${buttonTokens.BorderWidthBaseDefault} ${buttonTokens.BorderColorBaseKeyboardFocus},
        0 0 0 ${buttonTokens.ShadowWidthBaseKeyboardFocus} ${buttonTokens.ShadowColorBaseKeyboardFocus};
      outline: none;
    }
  `,
  draggable: css`
    cursor: grab;
    user-select: none;
  `,
  dragging: css`
    opacity: 0.6;
    cursor: grabbing;
    user-select: none;
  `,
  active: css`
    color: ${tagTokens.FontColorInformationalActiveDefault};
    background-color: ${tagTokens.BackgroundColorInformationalActiveDefault};
  `,
  activeClickable: css`
    &:hover {
      background-color: ${tagTokens.BackgroundColorInformationalActiveHover};
      cursor: pointer;
    }

    &:focus-visible {
      background-color: ${tagTokens.BackgroundColorInformationalActiveDown};
    }

    &:active {
      background-color: ${tagTokens.BackgroundColorInformationalActiveDown};
    }
  `,
};

const tagVariants = {
  'feedback-informational': css`
    background: ${tagTokens.BackgroundColorInformationalDefault};
    box-shadow: inset 0 0 0 ${tagTokens.BorderWidthBaseDefault} ${tagTokens.BorderColorInformationalDefault};
    color: ${tagTokens.FontColorInformationalDefault};
  `,
  'feedback-positive': css`
    background: ${tagTokens.BackgroundColorPositiveDefault};
    box-shadow: inset 0 0 0 ${tagTokens.BorderWidthBaseDefault} ${tagTokens.BorderColorPositiveDefault};
    color: ${tagTokens.FontColorPositiveDefault};
  `,
  'feedback-neutral': css`
    background: ${tagTokens.BackgroundColorNeutralDefault};
    box-shadow: inset 0 0 0 ${tagTokens.BorderWidthBaseDefault} ${tagTokens.BorderColorNeutralDefault};
    color: ${tagTokens.FontColorNeutralDefault};
  `,
  'feedback-negative': css`
    background: ${tagTokens.BackgroundColorNegativeDefault};
    box-shadow: inset 0 0 0 ${tagTokens.BorderWidthBaseDefault} ${tagTokens.BorderColorNegativeDefault};
    color: ${tagTokens.FontColorNegativeDefault};
  `,
  'feedback-notice': css`
    background: ${tagTokens.BackgroundColorNoticeDefault};
    box-shadow: inset 0 0 0 ${tagTokens.BorderWidthBaseDefault} ${tagTokens.BorderColorNoticeDefault};
    color: ${tagTokens.FontColorNoticeDefault};
  `,
  'feedback-pending': css`
    background: ${tagTokens.BackgroundColorPendingDefault};
    box-shadow: inset 0 0 0 ${tagTokens.BorderWidthBaseDefault} ${tagTokens.BorderColorPendingDefault};
    color: ${tagTokens.FontColorPendingDefault};
  `,
  'flex-orange-light': css`
    background: ${tagTokens.BackgroundColorOrangeLightDefault};
    color: ${tagTokens.FontColorOrangeLightDefault};
  `,
  'flex-orange-medium': css`
    background: ${tagTokens.BackgroundColorOrangeMediumDefault};
    color: ${tagTokens.FontColorOrangeMediumDefault};
  `,
  'flex-orange-dark': css`
    background: ${tagTokens.BackgroundColorOrangeDarkDefault};
    color: ${tagTokens.FontColorOrangeDarkDefault};
  `,
  'flex-red-light': css`
    background: ${tagTokens.BackgroundColorRedLightDefault};
    color: ${tagTokens.FontColorRedLightDefault};
  `,
  'flex-red-medium': css`
    background: ${tagTokens.BackgroundColorRedMediumDefault};
    color: ${tagTokens.FontColorRedMediumDefault};
  `,
  'flex-red-dark': css`
    background: ${tagTokens.BackgroundColorRedDarkDefault};
    color: ${tagTokens.FontColorRedDarkDefault};
  `,
  'flex-green-light': css`
    background: ${tagTokens.BackgroundColorGreenLightDefault};
    color: ${tagTokens.FontColorGreenLightDefault};
  `,
  'flex-green-medium': css`
    background: ${tagTokens.BackgroundColorGreenMediumDefault};
    color: ${tagTokens.FontColorGreenMediumDefault};
  `,
  'flex-green-dark': css`
    background: ${tagTokens.BackgroundColorGreenDarkDefault};
    color: ${tagTokens.FontColorGreenDarkDefault};
  `,
  'flex-lime-light': css`
    background: ${tagTokens.BackgroundColorLimeLightDefault};
    color: ${tagTokens.FontColorLimeLightDefault};
  `,
  'flex-lime-medium': css`
    background: ${tagTokens.BackgroundColorLimeMediumDefault};
    color: ${tagTokens.FontColorLimeMediumDefault};
  `,
  'flex-lime-dark': css`
    background: ${tagTokens.BackgroundColorLimeDarkDefault};
    color: ${tagTokens.FontColorLimeDarkDefault};
  `,
  'flex-yellow-light': css`
    background: ${tagTokens.BackgroundColorYellowLightDefault};
    color: ${tagTokens.FontColorYellowLightDefault};
  `,
  'flex-yellow-medium': css`
    background: ${tagTokens.BackgroundColorYellowMediumDefault};
    color: ${tagTokens.FontColorYellowMediumDefault};
  `,
  'flex-yellow-dark': css`
    background: ${tagTokens.BackgroundColorYellowDarkDefault};
    color: ${tagTokens.FontColorYellowDarkDefault};
  `,
  'flex-blue-light': css`
    background: ${tagTokens.BackgroundColorBlueLightDefault};
    color: ${tagTokens.FontColorBlueLightDefault};
  `,
  'flex-blue-medium': css`
    background: ${tagTokens.BackgroundColorBlueMediumDefault};
    color: ${tagTokens.FontColorBlueMediumDefault};
  `,
  'flex-blue-dark': css`
    background: ${tagTokens.BackgroundColorBlueDarkDefault};
    color: ${tagTokens.FontColorBlueDarkDefault};
  `,
  'flex-gray-light': css`
    background: ${tagTokens.BackgroundColorGrayLightDefault};
    color: ${tagTokens.FontColorGrayLightDefault};
  `,
  'flex-gray-medium': css`
    background: ${tagTokens.BackgroundColorGrayMediumDefault};
    color: ${tagTokens.FontColorGrayMediumDefault};
  `,
  'flex-gray-dark': css`
    background: ${tagTokens.BackgroundColorGrayDarkDefault};
    color: ${tagTokens.FontColorGrayDarkDefault};
  `,
  'flex-purple-light': css`
    background: ${tagTokens.BackgroundColorPurpleLightDefault};
    color: ${tagTokens.FontColorPurpleLightDefault};
  `,
  'flex-purple-medium': css`
    background: ${tagTokens.BackgroundColorPurpleMediumDefault};
    color: ${tagTokens.FontColorPurpleMediumDefault};
  `,
  'flex-purple-dark': css`
    background: ${tagTokens.BackgroundColorPurpleDarkDefault};
    color: ${tagTokens.FontColorPurpleDarkDefault};
  `,
  'flex-turquoise-light': css`
    background: ${tagTokens.BackgroundColorTurquoiseLightDefault};
    color: ${tagTokens.FontColorTurquoiseLightDefault};
  `,
  'flex-turquoise-medium': css`
    background: ${tagTokens.BackgroundColorTurquoiseMediumDefault};
    color: ${tagTokens.FontColorTurquoiseMediumDefault};
  `,
  'flex-turquoise-dark': css`
    background: ${tagTokens.BackgroundColorTurquoiseDarkDefault};
    color: ${tagTokens.FontColorTurquoiseDarkDefault};
  `,
};

/* @internal */
export const tagSizes = {
  default: css`
    min-height: ${tagTokens.FontLeadingBaseDefault};
  `,
  mini: css`
    border-radius: ${tagTokens.BorderRadiusMiniDefault};
    min-height: ${tagTokens.FontLeadingMiniDefault};
    line-height: 1;
  `,
};

/* @internal */
export const TagButtonWrapper = styled.button`
  ${resetBrowserButton}

  align-items: center;
  align-self: stretch;
  background: none;
  border-radius: ${tagTokens.BorderRadiusBaseDefault};
  display: inline-flex;
  justify-content: center;
  padding-left: ${tagTokens.SpacingHorizontalBaseDefault};
  padding-right: ${tagTokens.SpacingHorizontalBaseDefault};
  margin-left: -${tagTokens.SpacingHorizontalBaseDefault};
  transition-duration: 80ms;
  transition-property: box-shadow, color;
  transition-timing-function: ease-out;

  ${tagStates.focus};
`;

/* @internal */
export const TagElement = styled.div`
  align-items: center;
  border-radius: ${tagTokens.BorderRadiusBaseDefault};
  display: inline-flex;
  font-size: ${tagTokens.FontSizeBaseDefault};
  font-weight: ${tagTokens.FontWeightBaseDefault};
  justify-content: space-between;
  position: relative;
  max-width: 100%;

  // The design spec applies hover to the entire button, whether it has
  // - one action (clickable or TagButton) or
  // - both actions (clickable and TagButton)
  // This retrofits that until we can find a better way to do it
  ${({ theme }) =>
    !theme.tagActive &&
    css`
      :has(${TagButtonWrapper}) {
        &:hover {
          background: ${tagTokens.BackgroundColorInformationalHover};
          cursor: pointer;
        }
        &:active {
          background: ${tagTokens.BackgroundColorInformationalDown};
        }
      }
    `}

  ${({ theme }) => tagSizes[theme.tagSize]};
  ${({ theme }) => theme.tagClickable && tagStates.clickable};

  ${({ theme }) => tagVariants[theme.tagVariant]};

  ${({ theme }) =>
    theme.tagActive &&
    theme.tagVariant === 'feedback-informational' &&
    css`
      ${tagStates.active};
      box-shadow: none;

      ${theme.tagClickable &&
      css`
        ${tagStates.activeClickable}
      `};
    `}

  ${({ theme }) => theme.tagDraggable && tagStates.draggable};
  ${({ theme }) => theme.tagDragging && tagStates.dragging};
`;

/* @internal */
export const TagBody = styled.div`
  align-items: center;
  align-self: stretch;
  border-radius: ${tagTokens.BorderRadiusBaseDefault};
  display: flex;
  padding-left: ${tagTokens.SpacingHorizontalBaseDefault};
  padding-right: ${tagTokens.SpacingHorizontalBaseDefault};
  transition-duration: 80ms;
  transition-property: background-color, box-shadow, color;
  transition-timing-function: ease-out;

  ${({ theme }) => theme.tagEllipsis && `max-width: ${theme.tagEllipsis};`}

  &:focus-visible {
    // When there is an action sibling
    &:not(:only-child) {
      border-radius: ${tagTokens.BorderRadiusBaseDefault};
    }
  }
  ${tagStates.focus};
`;

/* @internal */
export const TagText = styled.div`
  ${({ theme }) =>
    theme.tagEllipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `};

  ${({ theme }) =>
    theme.tagDraggable &&
    css`
      margin-left: ${tagTokens.SpacingHorizontalDraggableDefault};
    `}
`;
